export default __webpack_public_path__ + "static/aiDevZone-24fde8b2406047704b149e8f81066341.png";